<template>
  <router-view/>
</template>

<script>
    export default {
        name: "App",
        created() {
            let query = this.$methods.get_query();
            if (query.token) {
                localStorage.setItem("token", query.token);
            }
            if (query.title) {
                document.title = decodeURIComponent(query.title)
            }
        },
    };
</script>

<style lang="less">
    //引入公共css样式
    @import './assets/css/public.less';
</style>
